import React from 'react';

import { useTranslation } from 'react-i18next';

import { BlockStack, BlockStackProps, Button, ButtonGroup } from '@shopify/polaris';

interface ModalActionsProps {
    inlineAlign?: BlockStackProps['inlineAlign'];
    cancelLabel?: string;
    submitLabel?: string;
    loading?: boolean;
    onSubmit: VoidFunction;
    onCancel?: VoidFunction;
    disabledSubmit?: boolean;
}

const ModalActions: React.FC<ModalActionsProps> = (props) => {
    const { inlineAlign = 'center', cancelLabel, submitLabel, loading, onSubmit, onCancel, disabledSubmit } = props;

    const { t } = useTranslation('translation', { keyPrefix: 'MODAL_ACTIONS' });

    return (
        <BlockStack inlineAlign={inlineAlign}>
            <ButtonGroup>
                {onCancel && (
                    <Button variant="secondary" onClick={onCancel} disabled={loading}>
                        {cancelLabel ?? t('CANCEL')}
                    </Button>
                )}

                <Button variant="primary" onClick={onSubmit} loading={loading} disabled={disabledSubmit}>
                    {submitLabel ?? t('SUBMIT')}
                </Button>
            </ButtonGroup>
        </BlockStack>
    );
};

export default ModalActions;
